import axios from 'axios';

const api = axios.create({
	baseURL: `${process.env.REACT_APP_API_URL}/api`,
	headers: {
		'Content-Type': 'application/json',
		'ngrok-skip-browser-warning': 'true',
	},
});

export const activateAppSumoLicense = ({ oauthCode, licenseKey }, token) =>
	api.post(
		'/appsumo/v2/activate',
		{ oauthCode, licenseKey },
		{
			headers: {
				Authorization: `Bearer ${token}`,
			},
		},
	);
